import React from 'react';
import { useSelector } from 'react-redux';

import { selectPrimarySubscription } from '../../../../auth/AuthSelectors';
import { PlanClassification } from '../../../../auth/AuthTypes';

const DownloadsRemaining = () => {
  let title = null;
  const primarySubscription = useSelector(selectPrimarySubscription);

  const hasMakerOrStarter =
    primarySubscription?.planClassification ===
      PlanClassification.STARTER_PLAN_CLASSIFICATION ||
    primarySubscription?.isMakerOnly;

  const hasDownloadsAvailable =
    primarySubscription?.monthlyDownloadsRemaining &&
    primarySubscription?.status?.toLowerCase?.() !== 'cancel';

  if (hasMakerOrStarter && hasDownloadsAvailable) {
    title = `${primarySubscription.monthlyDownloadsRemaining} downloads remaining this month`;
  }
  return <>{title}</>;
};

export default DownloadsRemaining;
